














import { PageMode } from '@/main/utils/pageMode';
import { listFactory } from '@/main/pages';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	computed: {
		displayFilter() {
			if (this.props.showFilter === false) {
				return this.props.showFilter;
			}

			return this.props.mode !== PageMode.SELECT_LIST;
		},
	},
});
